import Header from '../components/Header/Header';
import LegendPanel from '../../components/Map/panels/LegendPanel/LegendPanel';
import { ReactElement } from 'react';
import styled from 'styled-components';

const MapLayout = ({ children }: { children: ReactElement }) => {
  const queryParameters = new URLSearchParams(window.location.search);
  const hideHeader = queryParameters.get('hide-header');

  return (
    <UI_Wrapper>
      {hideHeader !== 'true' && <Header />}

      <div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: hideHeader ? '100%' : 'calc(100% - var(--header-height))' }}>
        <UI_Content>
          {children}
        </UI_Content>
      </div>

    </UI_Wrapper>
  );
};

export default MapLayout;

const UI_Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f2f2f2;
`;

const UI_Sidebar = styled.div`
  height: 100%;
  position: relative;
  transition: width 0.4s;
`;
const UI_Content = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;
